import React from 'react'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'

const Logo = styled.div`
  display: flex;
  align-items: center;
  img {
    height: ${props => (props.small ? 32 : 40)}px;
    transition: all 0.2s ease-out;
  }
  .brandName {
    display: flex;
    color: #000;
    margin-left: 8px;
    transition: all 0.2s ease-out;
    font-weight: ${fontWeight.bold};
    font-size: ${props => props.isSticky ? 16 : 18}px;
  }
`

export default ({ small, isSticky }) => (
  <Logo small={small} isSticky={isSticky}>
    <img src='/img/logo-icon.svg' alt='Tungtung' />
    <div className='brandName'>tungtung</div>
  </Logo>
)
